<div class="rti-carousel-item" [ngStyle]="style">
  <ng-content></ng-content>
</div>
